module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Ajouter des articles Rewards Bazaar',
        subTitle: `<b>${vars[0]}</b> ajouté pour la livraison`
    };

    return resources[label];
};
